<template>
  <div class="main-wrapper scroll-y custom-scrollbar view-ph-clients-details">

    <page-title :title="'Szczegóły klienta'" :back="true"></page-title>

    <slide-x-left-transition :duration="400" :delay="200">
      <div v-if="show">
        <h6 class="text-up">Dane lokalu</h6>
        <hr>
        <p v-if="name">Nazwa: {{ name }}</p>
        <p v-if="sfa">SFA: {{ sfa }}</p>
        <p v-if="tax_id">NIP: {{ tax_id }}</p>
        <p v-if="full_address">Adres: {{ full_address }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="300">
      <div v-if="show">
        <h6 class="text-up">Pracownicy</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <div v-if="employees"
         v-for="(item,index) in employees"
         :key="index">
      <item-user-employee
          :index="index+1"
          :employee_id="item.employee_id"
          :first_name="item.first_name"
          :last_name="item.last_name"
          :badge="item.badge"
          :roles="item.roles">
      </item-user-employee>
    </div>

    <slide-y-up-transition :duration="400" :delay="200">
      <p v-if="show && (!employees || employees.length === 0)" class="text-center">Nie ma jeszcze żadnych pracowników.</p>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="400">
      <div v-if="show && loyaltyStatus">
        <h6 class="text-up">Program Lojalnościowy</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="500">
      <card-loyalty-contract v-if="show && loyaltyStatus"
                             title="Umowa klienta"
                             :active="loyaltyActive"
                             :status="loyaltyStatus"
                             :place_name="name"
                             :brand="loyaltyContractBrand"
                             :uuid="loyaltyContractUuid"
                             :canConfirm="true"
                             :canRemove="!loyaltyContractReadyOnly">
      </card-loyalty-contract>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="600">
      <card-loyalty-activations v-if="show && loyaltyStatus"
                                :canInvite="loyaltyActivationsEnabled && !loyaltyContractReadyOnly">
      </card-loyalty-activations>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="700">
      <form-loyalty-filter-client-results v-if="showLoyalty && isLoyalty && show"/>
    </slide-x-left-transition>

    <ion-segment v-if="showLoyalty && isLoyalty"
                 mode="md"
                 :value="sliderIndex"
                 @ionChange="segmentChanged($event)"
                 scrollable
                 style="margin: 0">
      <template v-for="(item,index) in loyaltyResultsBox">
        <ion-segment-button mode="md" :value="index" :disabled="(item.status === 'inactive') ? true : false">
          <ion-label>{{ item.month }}</ion-label>
        </ion-segment-button>
      </template>
    </ion-segment>

    <ion-slides v-if="showLoyalty && isLoyalty"
                ref="slides"
                @ionSlideDidChange="slideChanged"
                :options="slideOpts"
                mode="md">
      <ion-slide v-for="(item,index) in loyaltyResultsBox" :key="index">
        <item-loyalty-result
            :index="index"
            :title="item.month"
            :status="item.status"
            :volume="item.volume"
            :tables="item.tables">
        </item-loyalty-result>
      </ion-slide>
    </ion-slides>

    <slide-x-left-transition :duration="400" :delay="800">
      <card-loyalty-vouchers v-if="showLoyaltyVouchers && isLoyalty"
                             :vouchers="loyaltyVouchers"
                             :sfa="sfa"
                             :year="year">
      </card-loyalty-vouchers>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="900">
      <h6 v-if="show && showLoyaltyChart && isLoyalty">Wolumen sprzedaży miesięcznej</h6>
    </slide-x-left-transition>

    <bar-chart v-if="showLoyaltyChart && isLoyalty"
               style="height: 550px"
               ref="salesChart"
               title1="Keg (HL)"
               title2="Butelka (HL)"
               :labels="chartLabels"
               :data1="loyaltyResultsChart.keg"
               :data2="loyaltyResultsChart.bottle">
    </bar-chart>

  </div>
</template>

<script>
  import { isObject } from 'lodash';
  import {mapGetters, mapState} from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import CardLoyaltyContract from '@/cards/CardLoyaltyContract';
  import ItemUserEmployee from '@/items/ItemUserEmployee';
  import ItemLoyaltyResult from '@/items/ItemLoyaltyResult';
  import CardLoyaltyActivations from '@/cards/CardLoyaltyActivations.vue';
  import FormLoyaltyFilterClientResults from '@/forms/loyalty/FormLoyaltyFilterClientResults.vue';
  import CardLoyaltyVouchers from '@/cards/CardLoyaltyVouchers.vue';
  import BarChart from '@/components/BarChart.vue';

  export default {
    name: 'PhClientsDetails',
    components: {
      PageTitle,
      CardLoyaltyContract,
      ItemUserEmployee,
      ItemLoyaltyResult,
      CardLoyaltyActivations,
      FormLoyaltyFilterClientResults,
      CardLoyaltyVouchers,
      BarChart
    },
    data() {
      return {
        show: false,
        // slider helpers
        sliderIndex: 0,
        sliderLength: 0,
        sliderEnd: false,
        // slider options
        slideOpts: {
          slidesPerView: 1,
        },
        // todo move to api
        chartLabels: ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        loading: state => state.clients.loading,
        settings: state => state.config.settings,
        year: state => state.loyalty.filterResultsForm.year,
        name: state => state.clients.single ? state.clients.single.name : null,
        sfa: state => state.clients.single ? state.clients.single.sfa : null,
        tax_id: state => state.clients.single ? state.clients.single.tax_id : null,
        full_address: state => state.clients.single ? state.clients.single.full_address : null,
        employees: state => state.clients.single ? state.clients.single.employees : null,
      }),
      isLoyalty(){
        return this.$store.state.clients.single ? this.$store.state.clients.single.loyalty_program : false
      },
      loyaltyActive(){
        return this.isLoyalty ? this.isLoyalty.active : null // "active: true jak jest potwierdzona"
      },
      loyaltyStatus(){
        return this.isLoyalty ? this.isLoyalty.status : null // "status: true jak jest umowa"
      },
      loyaltyContractBrand(){
        return this.isLoyalty ? this.isLoyalty.brand : null
      },
      loyaltyActivationsEnabled(){
        return this.isLoyalty ? this.settings.activationEnabled : null
      },
      loyaltyContractReadyOnly(){
        return this.isLoyalty ? this.isLoyalty.readOnly : null
      },
      loyaltyContractUuid(){
        return this.isLoyalty ? this.isLoyalty.contract_uuid : null
      },
      loyaltyResults(){
        return this.isLoyalty ? this.isLoyalty.results : null
      },
      loyaltyVouchers(){
        return this.isLoyalty ? this.isLoyalty.vouchers : null
      },
      loyaltyResultsBox(){
        return _.isObject(this.loyaltyResults) ? this.loyaltyResults.box : []
      },
      loyaltyResultsChart(){
        return _.isObject(this.loyaltyResults) ? this.loyaltyResults.chart : null
      },
      showLoyalty(){
        return this.loyaltyResultsBox.length > 0 ? true : false
      },
      showLoyaltyVouchers(){
        return this.loyaltyVouchers ? true : false
      },
      showLoyaltyChart(){
        return this.loyaltyResultsChart ? true : false
      },
      currentMonthIndex(){
        return new Date().getMonth()
      }
    },
    mounted() {
      this.show = true;
      let payload = {'ph_slug': this.getProfile.slug, 'client_slug': this.$route.params.slug};
      this.$store.dispatch('clients/PH_CLIENTS_DETAILS_REQUEST', payload).then(resp => {
          // and slide to current month
          this.slideTo(this.currentMonthIndex)
      });
    },
    methods: {
      slideChanged(){
        // update slider helpers
        this.$refs.slides.getActiveIndex().then(index => {
          this.sliderIndex = index
        })
        this.$refs.slides.length().then(length => {
          this.sliderLength = length
        })
        this.$refs.slides.isEnd().then(bool => {
          this.sliderEnd = bool
        })
      },
      slideTo(index){
        if(!this.$refs.slides) return
        this.$refs.slides.slideTo(index);
      },
      segmentChanged(e) {
        this.slideTo(e.target.value)
      }
    }
  }
</script>